const deviceSection = (index) => {

  const input = index == 0 ? "devicePrimary" : "deviceSecondary";

  return {
    uuid: {
      name: `${input}-uuid`,
      label: "UUID",
      type: "text",
      placeholder: "UUID",
      // errorMsg: "Device uuid is required.",
    },
    serial_no: {
      name: `${input}-serial_no`,
      label: "Serial Number",
      type: "text",
      placeholder: "Serial Number",
      errorMsg: "Device serial number is required.",
    },
    stop_id: {
      name: `${input}-stop_id`,
      label: "Stop ID",
      type: "text",
      placeholder: "Stop ID",
      errorMsg: "Device stop_id is required.",
    },
    // description: {
    //   name: `${input}-description`,
    //   label: "Additional Information",
    //   type: "text",
    //   placeholder: "Additional information...",
    //   // errorMsg: "Device uuid is required.",
    // },
    info: {
      name: `${input}-info`,
      label: "Device Search",
      type: "select",
      placeholder: "Search or select a device...",
      // errorMsg: "Device uuid is required.",
    },
    conditions: {
      vandalised: {
        name: `${input}-conditions-vandalised`,
        type: "checkbox"
      },
      damaged: {
        name: `${input}-conditions-damaged`,
        type: "checkbox"
      },
      audio: {
        name: `${input}-conditions-audio`,
        type: "checkbox"
      },
      power: {
        name: `${input}-conditions-power`,
        type: "checkbox"
      },
      frozen: {
        name: `${input}-conditions-frozen`,
        type: "checkbox"
      },
      location: {
        name: `${input}-conditions-location`,
        type: "checkbox"
      },
      other: {
        name: `${input}-conditions-other`,
        type: "text",
        placeholder: "Other",
        errorMsg: "If checked, a description is required."
      },
    },
    actions: {
      removed: {
        name: `${input}-actions-removed`,
        type: "checkbox"
      },
      installed: {
        name: `${input}-actions-installed`,
        type: "checkbox"
      },
      cleaned: {
        name: `${input}-actions-cleaned`,
        type: "checkbox"
      },
      battery_swap: {
        name: `${input}-actions-battery_swap`,
        type: "checkbox"
      },
      hardware_changed: {
        name: `${input}-actions-hardware_changed`,
        type: "checkbox"
      },
      cosmetically_fixed: {
        name: `${input}-actions-cosmetically_fixed`,
        type: "checkbox"
      },
      other: {
        name: `${input}-actions-other`,
        type: "text",
        placeholder: "Other",
        errorMsg: "If checked, a description is required."
      },
    },
    images: {
      name: `${input}-images`,
      label: "Image Upload",
      type: "array",
      errorMsg: "Inspection title is required."
    }
  }
};

const form = {
  formId: "new-inspection-form",
  formField: {
    title: {
      name: "title",
      label: "Title",
      type: "text",
      placeholder: "Title",
      errorMsg: "Inspection title is required.",
    },
    description: {
      name: "description",
      label: "Additional Information",
      type: "text",
      placeholder: "Additional information...",
      errorMsg: "Inspection description is required.",
    },
    maintenance_tag: {
      name: "maintenance_tag",
      label: "Maintenance Identifier",
      type: "text",
      placeholder: "N/A",
      errorMsg: "Identifier is required.",
    },
    location: {
      name: "location",
      label: "Location",
      type: "text",
      placeholder: "Location",
      errorMsg: "Location is required."
    },
    inspection_type: {
      name: "inspection_type",
      label: "Inspection Type",
      type: "text",
      placeholder: "Select inspection type",
      errorMsg: "Inspection type is required."
    },
    organisation_id: {
      name: "organisation_id",
      label: "Organisation",
      type: "text",
      placeholder: "Organisation",
    },
    recordedAt: {
      name: "recordedAt",
      label: "Reported At",
      type: "datetime-local",
      placeholder: "yyyy-MM-ddThh:mm",
    },
    priority: {
      name: "priority",
      label: "Priority",
      type: "text"
    },
    resolved: {
      name: "resolved",
      label: "Resolved",
      type: "checkbox",
    },
    // technician: {
    //   name: "technician",
    //   label: "Technician",
    //   type: "text",
    // },
    devicePrimary: deviceSection(0),
    deviceSecondary: deviceSection(1)
  }
};

export default form;
